export default __webpack_public_path__ + "static/media/MaterialIconsTwoTone-Regular.8f4a378a.ttf";